import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import * as S from './LoadingCell.styles';

export const LoadingCell = () => {
  return (
    <S.Root>
      <S.LeftWrapper>
        <SkeletonLoader areas={S.logoLoaderAreas} />
        <SkeletonLoader areas={S.nameLoaderAreas} />
      </S.LeftWrapper>
      <S.RightWrapper>
        <SkeletonLoader areas={S.rankLoaderAreas} />
      </S.RightWrapper>
    </S.Root>
  );
};
